<template>
  <div class="gameAreaDiv" :class="{gameFill: fillParent}" :style="{
    borderTopLeftRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTopRightRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTop: HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 4?'':'1px solid #ccc',
  }">
    <div class="gameRowWrap" :style="{height: fillParent ? '100%' : undefined}">
      <!-- 左侧分类导航: 点击定位到右侧瀑布对应分类, 滚动时自动跟随高亮 -->
      <div :style="{width:'76px', height: fillParent ? '100%' : undefined}">
        <div ref="scrollContainerRef" class="leftCategory" :style="{height: leftColHeight}">
          <div v-for="(item, index) in leftIconInfo" :key="index">
            <div v-if="HNewGameUIConfig.newGameUIType===4" @click="goSection(index)"
                 :style="{
                    width:'76px',
                    height:'30px',
                    marginBottom:'6px',
                    color:activeIndex === index?'white':'#888',
                    fontSize:'16px',
                    paddingLeft:'6px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    backgroundImage:activeIndex === index?`url(${iconJmttTitleBg})`:'',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'left',
                 }">
              {{item["name"]}}
            </div>
            <!-- 选中/未选中两张图都立即渲染加载, 用 v-show 切换显示, 切换瞬间选中图已就绪(不会等下载) -->
            <template v-if="HNewGameUIConfig.newGameUIType!==4">
              <HCacheImage v-show="activeIndex === index" @click="goSection(index)" :src="item.icon_press"
                           width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'"
                           style="margin-bottom: 6px;"/>
              <HCacheImage v-show="activeIndex !== index" @click="goSection(index)" :src="item.icon"
                           width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'"
                           style="margin-bottom: 6px;"/>
            </template>
          </div>
          <!-- 底部留白: type0 有底部 tabbar 需避让(+home indicator); 其它样式内嵌无 tabbar, 游戏区到底 -->
          <div :style="{height: HNewGameUIConfig.newGameUIType === 0 ? 'calc(10px + env(safe-area-inset-bottom))' : '12px', flexShrink: 0}"/>
        </div>
      </div>

      <!-- 右侧瀑布流: 所有分类依次平铺, 每个分类前插入分类名分割标题 -->
      <div :style="{width:'calc(100% - 76px)', height: fillParent ? '100%' : undefined}">
        <div ref="waterfallRef" class="waterfall" :style="{height: rightColHeight}"
             @scroll="onWaterfallScroll" @touchstart="onWfTouchStart" @wheel="markUserScroll">
          <div class="waterfall-section" v-for="(page, pIndex) in data" :key="page['Name'] ?? pIndex">
            <!-- 分类名分割标题(复用收藏游戏那种 ---xxx--- 居中样式); “我的”自带最近/收藏子分栏, 不再额外加分类标题 -->
            <div v-if="page['Name'] && page['Name'] !== '我的'" class="sectionTitle">
              <div class="sectionLine"/>
              <div class="sectionDot"/>
              <div :style="hcf.getTextStyle({color:'main',marginRight:5,marginLeft:5,fontWeight:'bold',addSize:1})">{{ page['Name'] }}</div>
              <div class="sectionDot"/>
              <div class="sectionLine"/>
            </div>
            <div class="allRowParent" v-for="eachTemplate in visibleTemplates(page)" :key="eachTemplate['Id']">
              <GameAreaParserTemplate :favoriteCallback="getLobbyData" :eachTemplate="eachTemplate"/>
            </div>
          </div>
          <!-- 底部留白: type0 有底部 tabbar 需避让(+home indicator); 其它样式内嵌无 tabbar, 游戏区到底 -->
          <div :style="{height: HNewGameUIConfig.newGameUIType === 0 ? 'calc(70px + env(safe-area-inset-bottom))' : '12px'}"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import GameAreaParserTemplate from "@/components/pages/home/GameAreaParserTemplate.vue";
  import {ref} from "vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const iconJmttTitleBg = hcf.getNewGameUIIcon("flag_choose.png");

  const props = defineProps({
    bottomContainerHeight: {type: Number, default: 0},
    // true: 高度交给 flex 撑满父容器(永利首页, 避免 px 测量漂移导致整页溢出)
    fillParent: {type: Boolean, default: false},
  });
  let useHttp = useHHttp();

  // 左右两列高度: fillParent 时用 100% 减去各自 margin-top(左 10px / 右 11px), 保证含外边距后正好填满父高、不溢出
  const leftColHeight = computed(() => props.fillParent ? 'calc(100% - 10px)' : props.bottomContainerHeight + 'px');
  const rightColHeight = computed(() => props.fillParent ? 'calc(100% - 11px)' : props.bottomContainerHeight + 'px');

  // 当前高亮的分类(由点击或滚动同步)
  const activeIndex = ref(0);
  const scrollContainerRef = ref();   // 左侧分类列
  const waterfallRef = ref();          // 右侧瀑布滚动容器

  let data = ref([]);
  let leftIconInfo = ref([]);

  // 滚动联动时把左侧高亮图标滚到列中间
  function scrollToCenter(index, isAnimate = true) {
    if (!scrollContainerRef.value) return;
    const targetYValue = 60 * index - 90;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({top: targetYValue, behavior: 'smooth'});
    } else {
      scrollContainerRef.value.scrollTop = targetYValue;
    }
  }

  function setActive(index) {
    if (index === activeIndex.value) return;
    activeIndex.value = index;
    scrollToCenter(index);
  }

  // 左侧 scroll-spy 仅在用户主动滑动/滚轮时跟随; 点击分类触发的程序滚动期间不跟随(避免来回跳)
  let userScrolling = false;
  function markUserScroll() { userScrolling = true; }

  // 固定时长的缓动滚动(取代原生 smooth: 原生时长随距离变化, 远距离会很慢)
  let scrollAnimId = null;
  const SCROLL_DURATION = 280; // ms, 不论远近都用同一时间
  function animateScrollTo(cont, to) {
    if (scrollAnimId) cancelAnimationFrame(scrollAnimId);
    const start = cont.scrollTop;
    const change = to - start;
    if (Math.abs(change) < 1) { cont.scrollTop = to; return; }
    const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2); // easeInOutCubic
    let startTs = null;
    function step(ts) {
      if (startTs === null) startTs = ts;
      const t = Math.min(1, (ts - startTs) / SCROLL_DURATION);
      cont.scrollTop = start + change * ease(t);
      scrollAnimId = t < 1 ? requestAnimationFrame(step) : null;
    }
    scrollAnimId = requestAnimationFrame(step);
  }

  // 点击左侧分类: 固定时长滚动右侧到对应分类锚点; 关闭跟随, 左侧固定停在点击的分类
  function goSection(index) {
    const cont = waterfallRef.value;
    if (!cont) return;
    const sections = cont.querySelectorAll('.waterfall-section');
    const target = sections[index];
    if (!target) return;
    userScrolling = false;
    activeIndex.value = index;
    scrollToCenter(index);
    // 用相对容器顶部的距离(不依赖 offsetParent), 基准与 scrollTop 一致, 定位才准
    const targetTop = target.getBoundingClientRect().top - cont.getBoundingClientRect().top + cont.scrollTop;
    animateScrollTo(cont, targetTop);
  }

  // 滚动联动(scroll-spy): 找到顶部越过判定线的最后一个分类; 滚到底部时强制高亮最后一个。
  function onWaterfallScroll() {
    if (!userScrolling) return;
    const cont = waterfallRef.value;
    if (!cont) return;
    const sections = cont.querySelectorAll('.waterfall-section');
    if (!sections.length) return;
    if (cont.scrollTop + cont.clientHeight >= cont.scrollHeight - 2) {
      setActive(sections.length - 1);
      return;
    }
    // 判定线: section 顶部相对容器顶 <= 70px 视为已进入(与 goSection 同一套 rect 基准)
    const contTop = cont.getBoundingClientRect().top;
    let active = 0;
    for (let i = 0; i < sections.length; i++) {
      const rel = sections[i].getBoundingClientRect().top - contTop;
      if (rel <= 70) active = i; else break;
    }
    setActive(active);
  }

  // 边界外溢拦截: 瀑布滚到顶/到底后, 手指继续朝边缘方向拖时阻止默认, 否则会带动整个首页一起滚动。
  // 项目全局启用了 default-passive-events, Vue 的 @touchmove 是被动监听无法 preventDefault,
  // 故 touchmove 用非被动监听手动绑定(见 onMounted)。
  let wfTouchStartY = 0;
  function onWfTouchStart(e) {
    wfTouchStartY = e.touches[0].clientY;
    userScrolling = true;
    // 用户在动画途中触摸: 立即停止程序滚动, 交还控制权
    if (scrollAnimId) { cancelAnimationFrame(scrollAnimId); scrollAnimId = null; }
  }
  function onWfTouchMove(e) {
    const el = waterfallRef.value;
    if (!el) return;
    const dy = e.touches[0].clientY - wfTouchStartY; // >0 下拉 / <0 上滑
    const atTop = el.scrollTop <= 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    if (((dy < 0 && atBottom) || (dy > 0 && atTop)) && e.cancelable) {
      e.preventDefault();
    }
  }

  // 过滤掉空的“收藏游戏”模块: 无任何收藏时不显示收藏分栏(也就没有“暂无收藏”提示)
  function visibleTemplates(page) {
    const tl = page['TemplateList'] ?? [];
    return tl.filter(t => !(t && t['Title'] === '收藏游戏' && (t['ItemList']?.length ?? 0) === 0));
  }

  function getLobbyData() {
    useHttp.request("/qp/game/lobby", (respData) => {
      leftIconInfo.value = [];
      data.value = respData.Data;
      for (let each of data.value) {
        leftIconInfo.value.push({
          "icon": each["Icon2"],
          'icon_press': each["Icon1"],
          'name': each['Name'],
        });
      }
    }, {isShowLoading: false})
  }

  onActivated(() => {
    scrollToCenter(activeIndex.value, false);
  });

  onMounted(() => {
    emitter.on("REFRESH_HOME_LOBBY_LIST", () => {
      getLobbyData();
    });
    getLobbyData();
    if (waterfallRef.value) {
      waterfallRef.value.addEventListener('touchmove', onWfTouchMove, {passive: false});
    }
  });

  onUnmounted(() => {
    if (scrollAnimId) { cancelAnimationFrame(scrollAnimId); scrollAnimId = null; }
    if (waterfallRef.value) {
      waterfallRef.value.removeEventListener('touchmove', onWfTouchMove);
    }
  });
</script>


<style scoped>
  .leftCategory {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .gameAreaDiv {
    display: flex;
    flex-direction: row;
    background-color: white;
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  /* 永利首页: 游戏区作为 flex 项填满父剩余高度, 内部两列再各自滚动 */
  .gameFill {
    flex: 1;
    min-height: 0;
  }

  .gameRowWrap {
    display: flex;
    width: 100%;
  }

  /* 右侧瀑布滚动容器 */
  .waterfall {
    margin-top: 11px;
    position: relative;
    overflow-y: auto;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
  }

  .waterfall-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 6px;
  }

  .allRowParent {
    display: flex;
    flex-direction: row;
  }

  /* 分类名分割标题 */
  .sectionTitle {
    width: 100%;
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .sectionLine {
    border-radius: 5px;
    width: 60px;
    height: 1px;
    background-color: var(--ct-main-color);
    opacity: 0.35;
  }

  .sectionDot {
    border-radius: 10px;
    width: 5px;
    height: 5px;
    border: 2px solid var(--ct-main-color);
    opacity: 0.55;
  }
</style>
